import React from 'react';
import './PetAnimations.css';

export default function GenericPetSvg({ size = 120, color, className = '' }) {
  const bodyColor = color || '#90CAF9';
  const lightColor = '#E3F2FD';

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 120 120"
      fill="none"
      className={`pet-svg pet-idle ${className}`}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Shadow */}
      <ellipse cx="60" cy="100" rx="26" ry="6" fill="#000" opacity="0.06" />
      {/* Body - cute blob */}
      <ellipse cx="60" cy="65" rx="32" ry="30" fill={bodyColor} />
      {/* Belly */}
      <ellipse cx="60" cy="72" rx="20" ry="18" fill={lightColor} />
      {/* Little nub feet */}
      <ellipse cx="42" cy="92" rx="8" ry="5" fill={bodyColor} />
      <ellipse cx="78" cy="92" rx="8" ry="5" fill={bodyColor} />
      {/* Little nub arms */}
      <ellipse cx="30" cy="68" rx="6" ry="10" fill={bodyColor} transform="rotate(-15 30 68)" />
      <ellipse cx="90" cy="68" rx="6" ry="10" fill={bodyColor} transform="rotate(15 90 68)" />
      {/* Eyes */}
      <circle cx="48" cy="55" r="6" fill="white" />
      <circle cx="72" cy="55" r="6" fill="white" />
      <circle cx="49.5" cy="56" r="4" fill="#2C2419" />
      <circle cx="73.5" cy="56" r="4" fill="#2C2419" />
      <circle cx="51" cy="54" r="1.5" fill="white" />
      <circle cx="75" cy="54" r="1.5" fill="white" />
      {/* Blush */}
      <ellipse cx="40" cy="64" rx="5" ry="3" fill="#F8A4C8" opacity="0.3" />
      <ellipse cx="80" cy="64" rx="5" ry="3" fill="#F8A4C8" opacity="0.3" />
      {/* Mouth */}
      <path d="M54 68C54 68 57 72 60 72C63 72 66 68 66 68" stroke="#2C2419" strokeWidth="1.5" strokeLinecap="round" fill="none" />
      {/* Little sprout on head */}
      <path d="M60 36C60 36 58 28 54 24" stroke="#8BC34A" strokeWidth="2" strokeLinecap="round" fill="none" />
      <ellipse cx="52" cy="23" rx="4" ry="3" fill="#8BC34A" transform="rotate(-20 52 23)" />
    </svg>
  );
}
